import 'whatwg-fetch'
import {API_URL} from '../constants/configValues'

const headerJson = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}
const auth = {
  postLogin(username, password) {
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/token-auth`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify({userName: username.toLowerCase(), password: password})
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        }
        if (response.status === 401) {
          reject(new Error('tài khoản hoặc mật khẩu không đúng'))
        }
        if (response.status === 404) {
          reject(new Error('tài khoản không đúng'))
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout() {
    return new Promise(resolve => {
      resolve(true)
    })
  },
  hasUser(value) {
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/accounts/hasuser/${value}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject(new Error(response.statusText))
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  postRegister(info) {
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/accounts/register`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(info)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject(new Error(response.statusText))
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default auth



// WEBPACK FOOTER //
// ./src/api/auth.js